import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ThankYouPage = () => {
  return (
    <div className="container text-center py-5">
      <div className="row justify-content-center">
        <div className="col-lg-6 col-md-8">
          <div className="card shadow-lg p-4">
            <div className="card-body">
              <img
                src="../assets/img/thankyou.png"
                alt="Thank You"
                className="thank-you-icon mb-4"
                style={{ width: "120px", height: "120px" }}
              />
              <h2 className="mb-3 text-success" style={{ color: '#F28123' }}>Thank You!</h2>
              <p className="mb-4">
                Thank you for your recent purchase with us! We truly appreciate
                your trust in our products and are excited to serve you.
              </p>
              <button
                className="btn btn-primary px-4"
                onClick={() => (window.location.href = "/")} 
                style={{ 'background-color': '#F28123' }}
              >
                Go Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
